import { http, setHTTPHeader } from './http.service'
import { IAccount } from '@/types/general'
import { create, fetch, fetchAll, fetchAllForUser, fetchBySubdomain, sendUSSSARosters } from '@/apis/account.api'

class AccountService {
  async create(account: IAccount) {
    return create(account)
  }

  async fetchAll() {
    return fetchAll()
  }

  async fetchAllForUser(userId) {
    return fetchAllForUser(userId)
  }

  async fetchBySubdomain(subdomain) {
    return fetchBySubdomain(subdomain)
  }

  async fetch(accountId) {
    return fetch(accountId)
  }

  async sendUSSSARosters(accountId) {
    return sendUSSSARosters(accountId)
  }
}

const instance = new AccountService()
export default instance
